import { VehicleFilters } from "../../hooks/useVehicleFilters";

// Configuration type for filter display logic
// Required<VehicleFilters> ensures all filter keys must have a config entry
// NonNullable<VehicleFilters[K]> for getLabel since it only handles active (non-null) values
type FilterConfigMap = {
  [K in keyof Required<VehicleFilters>]: {
    getLabel: (value: NonNullable<VehicleFilters[K]>) => string;
    isActive: (value: VehicleFilters[K]) => boolean;
  };
};

export const FILTER_CHIP_CONFIG: FilterConfigMap = {
  minCapacity: {
    getLabel: (value: number) => `Min Capacity (${value} pax)`,
    isActive: (value) => value !== null,
  },
  // Future filters can be added here:
  // maxPrice: {
  //   getLabel: (value: number) => `Max Price ($${value})`,
  //   isActive: (value) => value !== null,
  // },
  // vehicleTypes: {
  //   getLabel: (value: string[]) => `Vehicle Types (${value.length})`,
  //   isActive: (value) => value !== null && value.length > 0,
  // },
  // features: {
  //   getLabel: (value: string[]) => `Features (${value.length})`,
  //   isActive: (value) => value !== null && value.length > 0,
  // },
};